import { errorMessageFinder, ErrorWithMessage } from 'app/utils/errors';
import * as iots from 'io-ts';

const ErrorWithCode = iots.type({
  code: iots.string,
});

// Using a partial here because original ResponseError is called
// from JS a lot and we can't be sure all fields are properly set
const ResponseError = iots.partial({
  name:   iots.string,
  status: iots.number,
  url:    iots.string,
  method: iots.string,
});

export const getSignalingErrorMessage = errorMessageFinder([
  // This error is specifically coming from our API
  (t, error) =>
    ErrorWithCode.is(error) && error.code === 'Rtc.NoAvailableServer'
    ? t('rtc.errors.signaling-server-not-available')
    : null,
  // This error can come back from a dying signaling server that
  // sees there's no other server to redirect to. Everybody is dying.
  (t, error) =>
    ErrorWithCode.is(error) && error.code === 'NoServersAvailable'
    ? t('rtc.errors.signaling-server-not-available')
    : null,
  (t, error) =>
    ErrorWithMessage.is(error) &&
    (error.message === 'xhr poll error' ||
     error.message === 'websocket error')
    ? t('rtc.errors.signaling-server-disconnected')
    : null,
  // Generic response error
  (t, error) =>
    ResponseError.is(error) && error.name === 'ResponseError'
    ? t('rtc.errors.server-response', {
      details: `${error.status} ${error.method} ${error.url}`,
    })
    : null,
  // Fallback error
  (t, error) => t('rtc.errors.server-response', {
    details:
      ErrorWithMessage.is(error) ? error.message :
      ErrorWithCode.is(error) ? error.code :
      JSON.stringify(error),
  }),
]);
